/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-07-22 16:25:07
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-07-27 15:28:34
 * @FilePath: \大屏项目\src\components\element\attrs\cpt-realtime-position-option.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import defaultColor from "@/components/color";
export default {
    attribute:{
        label:'显示位置:',
        url: '',
        size:'medium',
        showname:true,
        showLable:true,
        zoomCtrlShow:false,  // 缩放按钮开关
        isQueryDetail:true,  
        cptTableData:[{ "name": "经度", "value": "", "namekey": "lng" },{ "name": "纬度", "value": "", "namekey": "lat" },{ "name": "图片", "value": "", "namekey": "url" },{ "name": "文本显示", "value": "", "namekey": "name" }],
        sonCptTableData:[{ "name": "父级", "value": "", "namekey": "pid" },{ "name": "子级", "value": "", "namekey": "sid" }],
        paramsId:'',
        bgColor: defaultColor[0],
        textColor: '#fff',
        radius: 6,
        zoom:12,
        centerx:116.331398,
        centery:39.897445,
        tareaValue:'1212',
        width: 40,
        height: 40,
        fit: 'fill',
        preview: false,
        autoRotate: false,
        rotateDuration: 2,
        bgColor: 'rgba(0,0,0,0)',
        textColor: '#000000',
        textSize: 12,
        loadBg: '#fff',
        mapType: 'BMAP_NORMAL_MAP',
        showCenterPoint: false,
        labelBgColor: '#fff',
        labelBorderColor: 'red',
        labelOffsetX: -10,
        labelOffsetY: 10,
        operator: '',
        lightField: '',
        threshold: '',
        lightWidth: 40,
        lightHeight: 40,
        lightTextColor: '#000000',
        LightTextSize: 12,
        LightLabelBgColor: '#fff',
        LightLabelBorderColor: 'red',
        labelWidth: 'unset',

        mapDrillDown: false,
        drillDownUrl: '',
        mapClick: false,
        mapZoom: false,
        drillDownZoom: 12, 
        sonZoom: 12, 
        mapDataSearch: false,
        drillDownWidth: 40,
        drillDownHeight: 40,
        drillDownTextColor: '#000000',
        drillDownTextSize: 12,
        drillDownLabelBgColor: '#fff',
        drillDownLabelBorderColor: 'red',


        pointClusterer: false,
        pointClustererRange: 10,
        pointClustererImage: '',
        pointClustererText: '',

        polyLine: false,
        polyLineStyle: 'lighter',
        polyLineColor: '#000',
        polyLineStrokeWeight: 5,
        polyLineImage: '',
        polyLineImageWidth: 16,
        polyLineImageHeight: 64,
        polyLineLabel: false,

        polyLineLabelBgColor: '#fff',
        polyLineLabelBorderColor: 'red',
        polyLineLabelFontColor: '#000',
        polyLineLabelFontSize: '14',
        polyLineLabelFontFamily: '',
        polyLineAuto: false,
        polyLineAutoTime: 1000,

        polyLineAuto: 'close',
        polyLineAutoTime: 0,
        polyLineLenTime: 20000,

        rowDataList: []


    },
    cptDataForm: {//动态数据配置
        dataSource: 1, //默认数据源1:静态数据，2:api接口,3:SQL,4:数据集,5:websocket
        pollTime: 0,//默认轮询时间
        dataText: '[{"lng": "116.399","lat": "39.910","url": "","name":"张"},{"lng": "116.387112","lat": "39.920977","url": "","name":"李"},{"lng": "116.385243","lat": "39.913063","url": "","name":"王"},{"lng": "116.394226","lat": "39.917988","url": "","name":"张"}]',//静态数据，必须为JSON格式
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },
}


